import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { Cookie, X } from "lucide-react";

const CookieBanner = () => {
  const { consentStatus, acceptCookies, rejectCookies } = useCookieConsent();

  // Don't show banner if user has already made a choice
  if (consentStatus !== "pending") {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background border-t border-border shadow-lg">
      <div className="container mx-auto max-w-4xl">
        <div className="flex flex-col gap-4">
          <div className="flex items-start gap-3">
            <Cookie className="w-6 h-6 text-primary shrink-0 mt-1" />
            <div className="flex-1">
              <p className="font-semibold text-foreground mb-2" role="heading" aria-level={2}>
                Questo sito utilizza i cookie
              </p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Utilizziamo cookie tecnici necessari per il corretto funzionamento del sito. 
                Inoltre, con il tuo consenso, potremmo utilizzare cookie analitici per migliorare 
                la tua esperienza di navigazione e comprendere come utilizzi il nostro sito.
              </p>
              <p className="text-sm text-muted-foreground mt-2">
                Per maggiori informazioni, consulta la nostra{" "}
                <Link to="/cookie-policy" className="text-primary hover:underline">
                  Cookie Policy
                </Link>{" "}
                e la{" "}
                <Link to="/privacy-policy" className="text-primary hover:underline">
                  Privacy Policy
                </Link>.
              </p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
            <Button
              variant="outline"
              onClick={rejectCookies}
              className="sm:order-1"
            >
              Rifiuta
            </Button>
            <Button
              onClick={acceptCookies}
              className="bg-primary hover:bg-primary/90 sm:order-2"
            >
              Accetta
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
